import React, { FunctionComponent, useState, useEffect } from 'react';
import { v1 as uuid } from 'uuid';
import { Skeleton } from '@material-ui/lab';
import { makeStyles, createStyles, Box, Grid } from '@material-ui/core';
import { Comment, CommentList } from '../../../../store/modules/application/types';
import AddCommentField from '../../../../components/AddCommentField';
import CommentsNode from '../../../../components/CommentsNode';
import EmptyRecord from '../../../../components/TableView/TableEmptyState';

type TimeSheetCommentProps = {
    loading: Boolean;
    timesheetId: string;
    readOnly: boolean;
    addTimeSheetComment: Function;
    getTimesheetComment: Function;
    timeSheetCommentList: CommentList;
};

const TimeSheetComment: FunctionComponent<TimeSheetCommentProps> = (props) => {
    const { addTimeSheetComment, loading, timesheetId, timeSheetCommentList, getTimesheetComment, readOnly } = props;
    const useStyles = makeStyles(() =>
        createStyles({
            addTimeSheetCommentDialog: { width: '70%' },
            comments: {
                width: '100%',
                marginTop: '40px',
                display: 'grid',
            },
        }),
    );
    //@ts-ignore
    const classes = useStyles();
    const [isAddTimeSheetCommentOpen, setAddTimeSheetCommentOpen] = useState<boolean>(false);
    const [comment, setComment] = useState<string>('');
    const handleChangeComment = (event: React.ChangeEvent<{ name?: string; value: string }>) => {
        setComment(event.target.value);
    };

    useEffect(() => {
        if (timesheetId) getTimesheetComment(timesheetId);
    }, [getTimesheetComment, timesheetId]);

    const handleAddTimeSheetCommentChange = () => {
        addTimeSheetComment(comment, timesheetId);
        setComment('');
        setAddTimeSheetCommentOpen(false);
    };

    const sortedList = (a: Comment, b: Comment) => {
        const date1 = new Date(b.timestamp).valueOf();
        const date2 = new Date(a.timestamp).valueOf();
        return date1 - date2;
    };

    const Loader = <Skeleton width="50%" />;

    return (
        <Box className={classes.addTimeSheetCommentDialog}>
            {loading ? (
                Loader
            ) : (
                <Grid container>
                    {!readOnly && (
                        <AddCommentField
                            isAddCommentFieldOpen={isAddTimeSheetCommentOpen}
                            setAddCommentFieldOpen={setAddTimeSheetCommentOpen}
                            setComment={setComment}
                            handleAddCommentChange={handleAddTimeSheetCommentChange}
                            handleChangeComment={handleChangeComment}
                            disabled={!!comment ? false : true}
                        />
                    )}
                    <Box className={classes.comments}>
                        {timeSheetCommentList &&
                        timeSheetCommentList.length > 0 &&
                        timeSheetCommentList !== undefined ? (
                            timeSheetCommentList
                                .sort((a: Comment, b: Comment) => {
                                    return sortedList(a, b);
                                })
                                .map((comment: Comment) => {
                                    return (
                                        <CommentsNode
                                            key={uuid()}
                                            user={comment.user.name}
                                            timestamp={comment.timestamp}
                                            text={comment.text}
                                        />
                                    );
                                })
                        ) : (
                            <Box>
                                <EmptyRecord title="No comments for this time sheet. " message=" " />
                            </Box>
                        )}
                    </Box>
                </Grid>
            )}
        </Box>
    );
};

export default TimeSheetComment;
